import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_VENDORS_REFRESH: createSagaAction('JOB_VENDORS_REFRESH'),

  GET_ALL_VENDORS: createSagaAction('GET_ALL_VENDORS'),

  JOB_VENDOR_CREATE: createSagaAction('JOB_VENDOR_CREATE'),
  JOB_VENDOR_UPDATE: createSagaAction('JOB_VENDOR_UPDATE'),
  JOB_VENDOR_DELETE: createSagaAction('JOB_VENDOR_DELETE'),

  CREATE_VENDOR_PURCHASE_ORDER: createSagaAction('CREATE_VENDOR_PURCHASE_ORDER'),
  UPDATE_VENDOR_PURCHASE_ORDER: createSagaAction('UPDATE_VENDOR_PURCHASE_ORDER'),
  GET_VENDOR_PURCHASE_ORDER: createSagaAction('GET_VENDOR_PURCHASE_ORDER'),

  UPLOAD_JOB_VENDOR_ATTACHMENT: createSagaAction('UPLOAD_JOB_VENDOR_ATTACHMENT'),
  GET_JOB_VENDOR_ATTACHMENTS: createSagaAction('GET_JOB_VENDOR_ATTACHMENTS'),
  UPDATE_JOB_VENDOR_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_JOB_VENDOR_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_JOB_VENDOR_ATTACHMENT: createSagaAction('DELETE_JOB_VENDOR_ATTACHMENT'),

  QUICK_ADD_VENDOR: createSagaAction('QUICK_ADD_VENDOR'),

  PURCHASE_ORDER_DELETE: createSagaAction('PURCHASE_ORDER_DELETE')
}

// Action Creators
export const actions = {
  jobVendorsRefresh: ({ jobId }) => ({
    type: constants.JOB_VENDORS_REFRESH.ACTION,
    jobId
  }),

  addJobVendor: ({ jobId, vendorId, userId }) => ({
    type: constants.JOB_VENDOR_CREATE.ACTION,
    jobId,
    vendorId,
    userId
  }),

  updateJobVendor: ({ jobId, vendorId, userId, content }) => ({
    type: constants.JOB_VENDOR_UPDATE.ACTION,
    jobId,
    vendorId,
    userId,
    content
  }),

  deleteJobVendor: ({ organizationId, jobId }) => ({
    type: constants.JOB_VENDOR_DELETE.ACTION,
    jobId,
    organizationId
  }),

  getAllVendors: () => ({
    type: constants.GET_ALL_VENDORS.ACTION
  }),

  getVendorPurchaseOrder: ({ jobId, next }) => ({
    type: constants.GET_VENDOR_PURCHASE_ORDER.ACTION,
    jobId,
    next
  }),

  createVendorPurchaseOrder: ({
    jobId,
    vendorId,
    userId,
    basicInfoData,
    sectionData,
    itemsData
  }) => ({
    type: constants.CREATE_VENDOR_PURCHASE_ORDER.ACTION,
    jobId,
    vendorId,
    userId,
    basicInfoData,
    sectionData,
    itemsData
  }),

  updateVendorPurchaseOrder: ({
    jobId,
    purchaseOrderId,
    vendorId,
    userId,
    basicInfoData,
    sectionData,
    grandTotal,
    itemsData
  }) => ({
    type: constants.UPDATE_VENDOR_PURCHASE_ORDER.ACTION,
    jobId,
    purchaseOrderId,
    vendorId,
    userId,
    basicInfoData,
    sectionData,
    grandTotal,
    itemsData
  }),

  // Attachment actions
  uploadAttachment: ({ formData, jobId, organizationId }) => ({
    type: constants.UPLOAD_JOB_VENDOR_ATTACHMENT.ACTION,
    formData,
    jobId,
    organizationId
  }),

  getAttachments: ({ jobId, organizationId }) => ({
    type: constants.GET_JOB_VENDOR_ATTACHMENTS.ACTION,
    jobId,
    organizationId
  }),

  updateAttachmentDescription: ({ attachmentId, jobId, organizationId, description, userId }) => ({
    type: constants.UPDATE_JOB_VENDOR_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    jobId,
    organizationId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, jobId, organizationId }) => ({
    type: constants.DELETE_JOB_VENDOR_ATTACHMENT.ACTION,
    attachmentId,
    jobId,
    organizationId
  }),

  quickAddVendor: ({ vendor, userId }) => ({
    type: constants.QUICK_ADD_VENDOR.ACTION,
    vendor,
    userId
  }),

  deletePurchaseOrder: ({ purchaseOrderId, jobId }) => ({
    type: constants.PURCHASE_ORDER_DELETE.ACTION,
    jobId,
    purchaseOrderId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_VENDORS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_VENDORS_REFRESH.SUCCESS:
      return {
        ...state,
        jobVendors: action.payload
      }
    case constants.GET_ALL_VENDORS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ALL_VENDORS.SUCCESS:
      return {
        ...state,
        allVendors: action.payload
      }
    case constants.JOB_VENDORS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_VENDOR_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_VENDOR_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_VENDOR_DELETE.SUCCESS:
      return {
        vendorPurchaseOrders: [],
        jobAttachments: [],
        ...state
      }
    case constants.CREATE_VENDOR_PURCHASE_ORDER.SUCCESS:
      return {
        ...state
      }
    case constants.UPDATE_VENDOR_PURCHASE_ORDER.SUCCESS:
      return {
        ...state
      }
    case constants.GET_VENDOR_PURCHASE_ORDER.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_VENDOR_PURCHASE_ORDER.SUCCESS:
      return {
        ...state,
        vendorPurchaseOrders: action.payload
      }

    case constants.UPLOAD_JOB_VENDOR_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_JOB_VENDOR_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_JOB_VENDOR_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_JOB_VENDOR_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_JOB_VENDOR_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_JOB_VENDOR_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_JOB_VENDOR_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    case constants.QUICK_ADD_VENDOR.SUCCESS:
      return {
        ...state
      }
    case constants.PURCHASE_ORDER_DELETE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobVendorActions.js